// src/pages/History/EarlyModern/OttomanEmpireGo.jsx
import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/Early_Modern_Period_-_Ottoman_Empire.png';

function HistoryPageOttomanEmpireGo() {
  return (
    <QuizPage
      title="History: Ottoman Empire"
      subTopic="Ottoman Empire"
      backgroundImage={historyImage}
      returnPath="/History-Ottoman-Empire"
    />
  );
}

export default HistoryPageOttomanEmpireGo;
